var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList } from '@dixa/lib-shared-habla';
import { memo, useCallback, useMemo, useState } from 'react';
import { TranslateTextDropdownButton } from 'components/translateTextDropdownButton';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import RecipientPill from '../../containers/messages/recipientPill';
import TextMessage from './TextMessage';
import { DetailedErrorMessage } from './detailedErrorMessage';
import { useMessageFiles } from './utils/useMessageFiles';
export const EmailMessage = (props) => {
    const { message, onFetchPrinter, onShowOriginal, originalEmailMeta } = props, otherProps = __rest(props, ["message", "onFetchPrinter", "onShowOriginal", "originalEmailMeta"]);
    const { emailTranslation } = useFeatureFlag(['email-translation']);
    const [renderedMessage, setRenderedMessage] = useState(message);
    const [isTranslated, setIsTranslated] = useState(false);
    const gutterButtons = useMemo(() => {
        if (!emailTranslation || !message.text) {
            return undefined;
        }
        return (_jsx(TranslateTextDropdownButton, { message: message.text, onTranslateEnd: (event) => {
                setRenderedMessage((message) => (Object.assign(Object.assign({}, message), { text: event.translatedText })));
                setIsTranslated(true);
            }, onTranslateError: () => {
                setIsTranslated(false);
            }, onRevert: () => {
                setRenderedMessage(message);
                setIsTranslated(false);
            } }));
    }, [emailTranslation, message]);
    const prepareMenu = useCallback(({ cc_list_v2, bcc_list_v2, to_list_v2, to, from, }) => {
        const toArray = to ? [to] : [];
        const toList = Array.isArray(to_list_v2) ? to_list_v2 : toArray;
        const ccList = Array.isArray(cc_list_v2) ? cc_list_v2 : [];
        const bccList = Array.isArray(bcc_list_v2) ? bcc_list_v2 : [];
        if (toList.length || ccList.length || bccList.length) {
            const fromAttributeAsRecipient = {
                email: from ? from : null,
                name: null,
            };
            return (_jsx(RecipientPill, { id: `cc-bcc-pill-${message.id}`, from: fromAttributeAsRecipient, toList: toList, ccList: ccList, bccList: bccList }));
        }
        return null;
    }, [message.id]);
    const menu = [
        ...(typeof otherProps.failed === 'string'
            ? [
                _jsx(_Fragment, { children: _jsx(DetailedErrorMessage, { message: otherProps.failed, description: otherProps.failureReason }) }),
            ]
            : []),
        ...(onShowOriginal
            ? [
                _jsxs(_Fragment, { children: [_jsx(ButtonList.Item, Object.assign({ icon: "mail", isLoading: originalEmailMeta.fetchOriginalEmail === 'loading', onClick: onShowOriginal }, { children: "View original email" })), _jsx(ButtonList.Item, Object.assign({ icon: "print", isLoading: originalEmailMeta.printerFriendly === 'loading', onClick: onFetchPrinter }, { children: "Print email" }))] }),
            ]
            : []),
    ];
    const { attachments, images } = useMessageFiles(message.inline_images, message.attached_files);
    return (_jsx(TextMessage, Object.assign({ attachments: attachments, images: images, nameMenu: prepareMenu(message), menu: menu, message: renderedMessage, gutterButtons: gutterButtons, isTranslated: isTranslated }, otherProps)));
};
export default memo(EmailMessage);
